import React from 'react';
import PropTypes from "prop-types";

//TOOLTIPS
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


const IconInfo = (props) => {
    const {
        mensaje,
        icono: Icono
    } = props;

    return (
        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>{mensaje}</Tooltip>}>
            <Icono className="pb-1" />
        </OverlayTrigger>
    )
}

IconInfo.prototype={icono:PropTypes.element}

export default IconInfo;